import {useComponentSlider} from "./component-slider/component-slider";
import {useComponentPeopleList} from "./component-people-list/component-people-list";
import {useComponentCollapse} from "./component-collapse/component-collapse";
import {useComponentSubscribe} from "./component-subscribe/component-subscribe";
import {useChangeLanguage} from "./component-change-language/component-change-language";

export function useComponents() {
    useComponentSlider();
    useComponentPeopleList();
    useComponentCollapse();
    useComponentSubscribe();
    useChangeLanguage();
}
